module.exports = __webpack_public_path__ + "img/product_just8899.3452634.webp";